import { render, staticRenderFns } from "./TgNavBar.vue?vue&type=template&id=4a8b34a0&"
import script from "./TgNavBar.vue?vue&type=script&lang=js&"
export * from "./TgNavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports